<template>
	<div>
		<v-card tile elevation="0" class="px-2">
			<v-card-text class="pa-0">
				<v-row v-if="aditivoApostila.isAguardandoEfetivacao">
					<v-col cols="12" sm="12">
						<v-alert icon="mdi-alert-circle-outline" color="primary" type="warning" text outlined>
							O aditivo/apostila foi formalizado com sucesso, porém sua validade passará a vigorar apenas
							no início do período de prorrogação.
						</v-alert>
					</v-col>
				</v-row>
				<h3 class="color-titulo font-weight-bold subtitle-1 mt-0 mb-8">Dados Gerais</h3>
				<v-form v-model="isFormValid" ref="formDadosGeraisAditivoApostila" lazy-validation>
					<v-row>
						<v-col cols="12" sm="3">
							<label-personalizado nome-campo="Tipo" obrigatorio-por-padrao></label-personalizado>
							<v-autocomplete
								id="aditivo-apostila-tipo"
								v-model="tipo"
								:items="tipoDatasource"
								:rules="tipoRules"
								placeholder="Selecione"
								class="ma-0 py-0 pt-3 mt-1"
								item-value="tipoValue"
								item-text="tipoText"
								clearable
								@change="formMudou"
								:disabled="aditivoApostila.isEfetivado"
							>
							</v-autocomplete>
						</v-col>
						<v-col cols="12" sm="3">
							<label-personalizado
								nome-campo="DOE"
								:obrigatorio-por-padrao="doeObrigatorio"
							></label-personalizado>
							<v-text-field
								id="aditivo-apostila-doe"
								v-model.trim="doeDatasource"
								:rules="doeRules"
								clearable
								maxlength="250"
								type="string"
								class="pt-3 mt-1"
								placeholder="Informe"
								@input="formMudou"
								:disabled="aditivoApostila.isEfetivado"
							>
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="2">
							<label-personalizado nome-campo="Prorrogar Ata"></label-personalizado>
							<v-radio-group
								:disabled="aditivoApostila.isEfetivado
								|| isAtaProrrogada
								|| aditivoApostila.isExisteAguardandoEfetivacaoNaAta"
								v-model="prorrogarValidadeDatasource"
								row
								class="pa-0 mt-6"
								@change="formMudou"
							>
								<v-radio label="Sim" :value="true"></v-radio>
								<v-radio label="Não" :value="false"></v-radio>
							</v-radio-group>
						</v-col>
						<v-col cols="12" sm="2" v-if="prorrogarValidadeDatasource">
							<input-text-de-data
								:disabled="aditivoApostila.isEfetivado
								|| isAtaProrrogada
								|| aditivoApostila.isExisteAguardandoEfetivacaoNaAta"
								:is-obrigatorio="true"
								nome-do-campo="Início Validade"
								:validation-rules="inicioValidadeRules"
								:value.sync="validadesDatasource.inicioValidade"
								:error="errorVigencia"
								:error-messages="mensagemVigencia"
								@update:value="formMudou"
							></input-text-de-data>
						</v-col>
						<v-col cols="12" sm="2" v-if="prorrogarValidadeDatasource">
							<input-text-de-data
								:disabled="aditivoApostila.isEfetivado
								|| isAtaProrrogada
								|| aditivoApostila.isExisteAguardandoEfetivacaoNaAta"
								:is-obrigatorio="true"
								nome-do-campo="Fim Validade"
								:value.sync="validadesDatasource.fimValidade"
								:validation-rules="fimValidadeRules"
								:error="errorVigencia"
								:error-messages="mensagemVigencia"
								@update:value="formMudou"
							></input-text-de-data>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" sm="12">
							<label-personalizado nome-campo="Descrição" obrigatorio-por-padrao></label-personalizado>
							<v-text-field
								id="aditivo-apostila-descricao"
								v-model.trim="descricaoDatasource"
								:rules="descricaoRules"
								clearable
								maxlength="4000"
								counter="4000"
								type="string"
								class="pt-3 mt-1"
								placeholder="Informe a descrição"
								@input="formMudou"
								:disabled="aditivoApostila.isEfetivado"
							>
							</v-text-field>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" sm="12">
							<label-personalizado
								nome-campo="Justificativa"
								:obrigatorio-por-padrao="justificativaObrigatoria"
							></label-personalizado>
							<v-text-field
								id="aditivo-apostila-justificativa"
								v-model.trim="justificativaDatasource"
								:rules="justificativaRules"
								clearable
								maxlength="4000"
								counter="4000"
								type="string"
								class="pt-3 mt-1"
								placeholder="Informe a justificativa"
								@input="formMudou"
								:disabled="aditivoApostila.isEfetivado"
							>
							</v-text-field>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
		</v-card>
		<v-divider></v-divider>
		<div>
			<div class="d-flex justify-lg-space-between my-4 px-2">
				<h3 class="color-titulo font-weight-bold subtitle-1 mt-0">Itens</h3>
				<div>
					<botao-primario
						v-if="podeExibirBotaoCancelarSupressaoAcrescimo"
						v-az-auth="permissoes.aditivoApostilaCancelarAcrescimoSupressao"
						outlined
						icone="mdi-close-circle-outline"
						cor-icone="primary"
						nome-botao="Cancelar Supressão/Acréscimo"
						class="mr-2"
						@click="abrirOuFecharModalConfirmacaoCancelarSupressaoAcrescimo"
					></botao-primario>
					<botao-primario
						v-az-auth="permissoes.aditivoApostilaAcrescimoSupressao"
						id="supressaoAcrescimo"
						outlined
						icone="add_circle"
						cor-icone="primary"
						nome-botao="Supressão/Acréscimo"
						class="btn-supressao-acrescimo mr-2"
						@click="abrirOuFecharModalSupressaoAcrescimo"
						:disabled="aditivoApostila.isEfetivado"
					></botao-primario>
					<botao-primario
						v-az-auth="permissoes.itemAditivoApostilaCancelarDescancelar"
						id="cancelar"
						outlined
						icone="mdi-close-circle-outline"
						cor-icone="primary"
						nome-botao="Cancelar Item"
						@click="cancelarDescancelar(true)"
						:disabled="aditivoApostila.isEfetivado"
					></botao-primario>
				</div>
			</div>
			<primeira-etapa-aditivo-apostila-listagem
				:total-paginas="listagem.totalPaginas"
				:total-itens="listagem.totalItens"
				:paginacao="listagem.paginacao"
				:itens-aditivo-apostila="listagem.datasource"
				@paginar="paginarAditivoApostilaItensListagem"
				@resetar-page="resetarPaginaItemAditivoApostilaListagem"
				@excluir="excluirItens"
				@cancelar-descancelar="cancelarDescancelar"
			></primeira-etapa-aditivo-apostila-listagem>
		</div>
		<v-divider></v-divider>
		<v-card-actions class="bg-white my-2 py-2 justify-space-between">
			<botao-cancelar @cancelar="voltarParaListagem"></botao-cancelar>
			<div class="d-flex aditivo-apostila-btn-action">
				<botao-primario
					v-az-auth="permissoes.aditivoApostilaEfetivar"
					@click="validaSePossuiDocumentosParaEfetivacao"
					nome-botao="Efetivar"
					:disabled="isBotaoEfetivarDisabled || aditivoApostila.isEfetivado"
				></botao-primario>
				<botao-primario
					v-az-auth="permissoes.aditivoApostilaSalvar"
					@click="salvarDadosGerais"
					nome-botao="Salvar"
					:disabled="isBotaoSalvarDisabled || aditivoApostila.isEfetivado"
				></botao-primario>
			</div>
		</v-card-actions>

		<modal-supressao-acrescimo-aditivo-apostila
			v-if="mostrarModalSupressaoAcrescimo"
			:exibir="mostrarModalSupressaoAcrescimo"
			:idAditivoApostila="idAditivoApostila"
			:quantitativo-itens="quantitativoItens"
			@fechar-modal="abrirOuFecharModalSupressaoAcrescimo"
			@salvar="salvarQuantidadeAcrescimoSupressao"
		></modal-supressao-acrescimo-aditivo-apostila>

		<modal-confirmacao
			:exibir="exibirModalConfirmarCancelarSupressaoAcrescimo"
			titulo-modal="Cancelar supressão/acréscimo"
			subtitulo-modal="Deseja realmente cancelar?"
			mensagem="A supressão/acréscimo realizada será desfeita."
			@fechar-modal="abrirOuFecharModalConfirmacaoCancelarSupressaoAcrescimo"
			@confirmar="cancelarSupressaoAcrescimo"
		></modal-confirmacao>

		<modal-confirmacao
			:exibir="exibirModalConfirmarDocumentosPncp"
			titulo-modal="Efetivar"
			subtituloModal="Deseja realmente efetivar?"
			mensagem="Atenção! Não possui documentos de envio para PNCP. Essa é uma ação permanente!"
			@fechar-modal="abrirOuFecharModalConfirmacaoConfirmarDocumentosPncp"
			@confirmar="efetivarAditivoApostila"
		></modal-confirmacao>
	</div>
</template>
<script>
import BotaoPrimario from '@/views/components/BotaoPrimario.vue'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import BotaoCancelar from '@/views/components/BotaoCancelar.vue'
import { actionTypes, mutationTypes, routesNames, situacoes } from '@/core/constants'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import PrimeiraEtapaAditivoApostilaListagem from '@/views/pages/ata/acessar/aditivo-apostila/primeira-etapa/listagem/PrimeiraEtapaAditivoApostilaListagem.vue'
import ModalSupressaoAcrescimoAditivoApostila from './modal-supressao-acrescimo/ModalSupressaoAcrescimoAditivoApostila.vue'
import { mapState } from 'vuex'
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'
import TextoTooltip from '@/views/components/TextoTooltip.vue'
import { DataUtils } from '@/core/utils'

export default {
	name: 'primeira-etapa-aditivo-apostila',
	components: {
		TextoTooltip,
		ModalConfirmacao,
		ModalSupressaoAcrescimoAditivoApostila,
		PrimeiraEtapaAditivoApostilaListagem,
		BotaoCancelar,
		LabelPersonalizado,
		BotaoPrimario,
	},
	mixins: [validacaoFormulario],
	emits: ['foi-salvo'],
	data() {
		return {
			quantitativoItens: null,
			listagem: this.initializeAditivoApostilaItensListagem(),
			mostrarModalSupressaoAcrescimo: false,
			exibirModalConfirmarCancelarSupressaoAcrescimo: false,
			idAditivoApostila: this.$route.params.idAditivoApostila,
			isFormValid: false,
			hasItens: false,
			rotaListagem: routesNames.ATA.ATA_ACESSAR_GESTAO_ATA_VIEW,
			tipoSelecionado: null,
			tipoDatasource: [
				{ tipoValue: 'ADITIVO', tipoText: 'Aditivo' },
				{ tipoValue: 'APOSTILA', tipoText: 'Apostila' },
			],
			tipoRules: [(v) => this.regraObrigatoriedade(v, 'Tipo é obrigatório.')],
			descricaoDatasource: '',
			descricaoRules: [
				(v) => this.regraObrigatoriedade(v, 'Descrição é obrigatória.'),
				(v) => !v || v?.length <= 4000 || 'O campo descrição deve ser igual ou menor do que 4000 caracteres.',
			],
			justificativaDatasource: '',
			justificativaRules: [
				(v) => (this.justificativaObrigatoria ? !!v : true) || 'Justificativa é obrigatória.',
				(v) =>
					!v || v?.length <= 4000 || 'O campo justificativa deve ser igual ou menor do que 4000 caracteres.',
			],
			doeRules: [
				(v) => (this.doeObrigatorio ? !!v : true) || 'Número do DOE é obrigatório.',
				(v) => !v || v?.length <= 250 || 'O campo doe deve ser igual ou menor do que 250 caracteres.',
			],
			doeDatasource: '',
			validadesDatasource: { inicioValidade: null, fimValidade: null },
			inicioValidadeRules: [(v) => this.regraObrigatoriedade(v, 'Inicio da validade é obrigatória.')],
			fimValidadeRules: [(v) => this.regraObrigatoriedade(v, 'Fim da validade é obrigatória.')],
			errorVigencia: false,
			isAtaProrrogada: false,
			prorrogarValidadeDatasource: false,
			mensagemVigencia: ['O prazo da validade da ata não pode ser maior que 1 (um) ano.'],
			isBotaoEfetivarDisabled: true,
			isBotaoSalvarDisabled: false,
			utilizaVigenciaDias: this.$store.state.parametrosSistema.utilizaVigenciaDias,
			exibirModalConfirmarDocumentosPncp: false,
		}
	},
	computed: {
		...mapState({
			aditivoApostila: (state) => state.aditivoApostila,
		}),
		tipo: {
			get() {
				return this.tipoSelecionado
			},
			set(value) {
				this.tipoSelecionado = value
			},
		},
		podeExibirBotaoCancelarSupressaoAcrescimo() {
			return !this.aditivoApostila.isEfetivado && this.aditivoApostila.quantidade !== null
		},
		justificativaObrigatoria() {
			return this.$store.state.parametrosSistema.justificativaObrigatoriaAditivoApostila
		},
		doeObrigatorio() {
			return this.$store.state.parametrosSistema.doeAditivoApostilaObrigatorio && this.tipoSelecionado === 'ADITIVO'
		},
	},
	watch: {
		validadesDatasource: {
			handler(novoValor) {
				const diferencaValida = this.utilizaVigenciaDias
					? DataUtils.isDiferencaEntreDatasMenorQueQtdAnos(novoValor.inicioValidade, novoValor.fimValidade, 1)
					: DataUtils.isDiferencaEntreDatasMenorIgualA(
							novoValor.inicioValidade,
							novoValor.fimValidade,
							1,
							'year',
					  )

				this.errorVigencia = !diferencaValida
			},
			deep: true,
		},
	},
	async created() {
		await this.buscarDadosGerais()
		await this.carregarListagem()
	},
	methods: {
		voltarParaListagem() {
			this.$router.push({
				name: this.rotaListagem,
			})
		},
		initializeAditivoApostilaItensListagem() {
			return {
				totalPaginas: 0,
				totalItens: 0,
				filtro: this.$store.state.itemAditivoApostila.filtro,
				paginacao: this.$store.state.itemAditivoApostila.paginacao,
				datasource: [],
			}
		},
		async buscarItensAditivoApostilaListagem() {
			const { itens, totalElements, totalPages, quantitativo } = await this.$store.dispatch(
				actionTypes.ITEM_ADITIVO_APOSTILA.BUSCAR_ITENS_ADITIVO_APOSTILA_LISTAGEM,
			)
			for (let item of itens) {
				await this.atribuirFornecedoresReservaNoItem(item)
			}
			this.quantitativoItens = quantitativo
			this.listagem.datasource = itens
			this.listagem.totalItens = totalElements
			this.listagem.totalPaginas = totalPages
			this.hasItens = totalElements > 0
		},
		async efetivarAditivoApostila() {
			if (this.aditivoApostila.isEfetivado) return

			await this.$store
				.dispatch(
					actionTypes.ADITIVO_APOSTILA.EFETIVAR_ADITIVO_APOSTILA,
					this.montarObjEfetivarAditivoApostila(),
				)
				.then(async ({ data }) => {
					this.mostrarNotificacaoSucessoDefault()
					this.abrirOuFecharModalConfirmacaoConfirmarDocumentosPncp(false)

					const situacao = data.situacao

					if (situacao === situacoes.ADITIVO_APOSTILA.AGUARDANDO_EFETIVACAO.value) {
						this.aditivoApostila.isAguardandoEfetivacao = true
					}

					this.aditivoApostila.isEfetivado = true

					await this.buscarItensAditivoApostilaListagem()

					if (data.idAtaProrrogada && String(this.$route.params.id) !== String(data.idAtaProrrogada)) {
						await this.$router.replace({ params: { id: data.idAtaProrrogada } })
					}
				})
		},
		async paginarAditivoApostilaItensListagem(paginacao) {
			this.setPaginacaoItensAditivoApostilaListagem(paginacao)
			await this.buscarItensAditivoApostilaListagem()
		},
		async carregarListagem() {
			await this.setFiltroItensAditivoApostilaListagem()
			await this.buscarItensAditivoApostilaListagem()
		},
		setPaginacaoItensAditivoApostilaListagem(paginacao) {
			this.$store.commit(mutationTypes.ITEM_ADITIVO_APOSTILA.SET_PAGINACAO_LISTAGEM, paginacao)
		},
		setFiltroItensAditivoApostilaListagem() {
			this.listagem.filtro.idAditivoApostila = this.idAditivoApostila
			this.$store.commit(mutationTypes.ITEM_ADITIVO_APOSTILA.SET_FILTRO_LISTAGEM, this.listagem.filtro)
		},
		resetarPaginaItemAditivoApostilaListagem() {
			this.$store.commit(mutationTypes.ITEM_ADITIVO_APOSTILA.RESETAR_PAGINA_LISTAGEM)
		},
		async buscarDadosGerais() {
			const dados = await this.$store.dispatch(
				actionTypes.ADITIVO_APOSTILA.BUSCAR_DADOS_GERAIS_ADITIVO_APOSTILA,
				this.idAditivoApostila,
			)
			this.$emit('foi-salvo', !!dados.tipo)
			this.tipoSelecionado = dados.tipo
			this.descricaoDatasource = dados.descricao || ''
			this.justificativaDatasource = dados.justificativa || ''
			this.doeDatasource = dados.doe || ''
			this.prorrogarValidadeDatasource = dados.isEmProrrogacao
			this.isAtaProrrogada = dados.isAtaProrrogada
			this.validadesDatasource.inicioValidade = dados.inicioValidade
			this.validadesDatasource.fimValidade = dados.fimValidade

			this.setarVariaveisDeControle(dados)
		},
		setarVariaveisDeControle(dados) {
			this.isBotaoEfetivarDisabled =
				(this.justificativaObrigatoria && !dados.justificativa) || !dados.descricao || !dados.tipo
			this.aditivoApostila.isEfetivado = dados.situacao === situacoes.ADITIVO_APOSTILA.EFETIVADO.value
				|| dados.situacao === situacoes.ADITIVO_APOSTILA.AGUARDANDO_EFETIVACAO.value
			this.aditivoApostila.isAguardandoEfetivacao = dados.situacao === situacoes.ADITIVO_APOSTILA.AGUARDANDO_EFETIVACAO.value
			this.aditivoApostila.isExisteAguardandoEfetivacaoNaAta = dados.isExisteAguardandoEfetivacaoNaAta
			this.aditivoApostila.numeroCasasDecimaisQtde = dados.numeroCasasDecimaisQtde
			this.aditivoApostila.numeroCasasDecimaisValores = dados.numeroCasasDecimaisValores
			this.aditivoApostila.quantidade = dados.quantidade
			this.aditivoApostila.cabecalho = {
				numeroAditivoApostila: dados.numeroAditivoApostila,
				dataCriacao: dados.dataCriacao,
				usuario: dados.usuario,
				inicioVigencia: dados.inicioVigencia,
				fimVigencia: dados.fimVigencia,
				numeroAta: dados.numeroAta,
			}
			this.aditivoApostila.situacao = dados.situacao
		},
		async salvarDadosGerais() {
			if (this.aditivoApostila.isEfetivado) return

			if (this.$refs.formDadosGeraisAditivoApostila.validate() && !this.errorVigencia) {
				await this.$store
					.dispatch(
						actionTypes.ADITIVO_APOSTILA.SALVAR_DADOS_GERAIS_ADITIVO_APOSTILA,
						this.montarObjDadosGerais(),
					)
					.then(() => {
						this.mostrarNotificacaoSucessoDefault()
						this.buscarDadosGerais()
					})
					.finally(() => {
						this.$emit('foi-salvo', true)
					})
			}
		},
		montarObjDadosGerais() {
			return {
				idAditivoApostila: this.idAditivoApostila,
				body: {
					tipo: this.tipoSelecionado,
					descricao: this.descricaoDatasource,
					justificativa: this.justificativaDatasource,
					doe: this.doeDatasource,
					inicioValidade: this.prorrogarValidadeDatasource ? this.validadesDatasource.inicioValidade : null,
					fimValidade: this.prorrogarValidadeDatasource ? this.validadesDatasource.fimValidade : null,
				},
			}
		},
		abrirOuFecharModalSupressaoAcrescimo() {
			this.mostrarModalSupressaoAcrescimo = !this.mostrarModalSupressaoAcrescimo
		},
		abrirOuFecharModalConfirmacaoCancelarSupressaoAcrescimo() {
			this.exibirModalConfirmarCancelarSupressaoAcrescimo = !this.exibirModalConfirmarCancelarSupressaoAcrescimo
		},
		abrirOuFecharModalConfirmacaoConfirmarDocumentosPncp(exibir) {
			this.exibirModalConfirmarDocumentosPncp = !!exibir
		},
		async validaSePossuiDocumentosParaEfetivacao() {
			const { existeDocumentos } = await this.$store.dispatch(
				actionTypes.ADITIVO_APOSTILA.EXISTE_DOCUMENTOS_PARA_PNCP_ADITIVO_APOSTILA,
				this.idAditivoApostila,
			)

			if (!existeDocumentos && this.tipoSelecionado === 'ADITIVO') {
				this.abrirOuFecharModalConfirmacaoConfirmarDocumentosPncp(true)
				return
			}

			await this.efetivarAditivoApostila()
		},

		async salvarQuantidadeAcrescimoSupressao(dados) {
			const payload = {
				...dados,
				idsItensAditivoApostila: this.listagem.datasource.map((item) => item.id),
			}

			await this.$store
				.dispatch(actionTypes.ADITIVO_APOSTILA.SALVAR_QUANTIDADE_ACRESCIMO_SUPRESSAO, payload)
				.then((response) => {
					if (response.message) this.mostrarNotificacaoWarning(response.message)
					else this.mostrarNotificacaoSucessoDefault()

					this.carregarListagem()
					this.aditivoApostila.quantidade = dados.quantidade
				})
		},
		async cancelarSupressaoAcrescimo() {
			await this.$store.dispatch(
				actionTypes.ADITIVO_APOSTILA.CANCELAR_ACRESCIMO_SUPRESSAO,
				this.idAditivoApostila,
			)
			this.mostrarNotificacaoSucessoDefault()
			await this.carregarListagem()
			this.aditivoApostila.quantidade = null
			this.abrirOuFecharModalConfirmacaoCancelarSupressaoAcrescimo()
		},
		formMudou() {
			this.isBotaoEfetivarDisabled = true
		},
		montarObjEfetivarAditivoApostila() {
			return {
				idAditivoApostila: this.idAditivoApostila,
			}
		},
		async atribuirFornecedoresReservaNoItem(itemAditivoApostila) {
			itemAditivoApostila.fornecedores = await this.buscarFornecedores(itemAditivoApostila.id)
		},
		async buscarFornecedores(idItemAditivoApostila) {
			const fornecedores = await this.$store.dispatch(
				actionTypes.ADITIVO_APOSTILA.BUSCAR_FORNECEDORES_POR_ITEM_ADITIVO_APOSTILA,
				idItemAditivoApostila,
			)

			return fornecedores
		},

		async excluirItens() {
			await this.carregarListagem()
		},
		async cancelarDescancelar(cancelado) {
			await this.$store
				.dispatch(actionTypes.ITEM_ADITIVO_APOSTILA.CANCELAR_DESCANCELAR_ITENS_ADITIVO_APOSTILA, {
					idAditivoApostila: this.idAditivoApostila,
					cancelado,
				})
				.then(async () => {
					this.$store.commit(mutationTypes.ITEM_ADITIVO_APOSTILA.ITEM_ADITIVO_APOSTILA_SELECIONADO, [])
					this.mostrarNotificacaoSucessoDefault()
					await this.carregarListagem()
				})
		},
	},
}
</script>
<style lang="stylus" scoped>
.aditivo-apostila-btn-action
	gap: 20px;

.color-titulo
	color: var(--v-primary-base);
</style>
